export interface MunicipalUserInfo {
    firstName: string;
    lastName: string;
    municipalityUnitCode?: string;
    municipalityCode?: string;
}

export interface InvoiceAddress {
    id: string;
    firstName: string;
    lastName: string;
    town: string;
    postalCode: string;
    email: string;
    companyName?: string;
    reference?: string;
    line1: string;
    line2?: string;
    phone: string;
    organizationNumber?: string;
}

export enum UserType {
    anonymous = 'Anonymous',
    private = 'Private',
    company = 'Company',
    punchout = 'Punchout',
}
